export const GET_HISTORY_DEVICE = 'GET_HISTORY_DEVICE';
export const GET_HISTORY_DEVICE_SUCCESS = 'GET_HISTORY_DEVICE_SUCCESS';
export const GET_HISTORY_DEVICE_ERROR = 'GET_HISTORY_DEVICE_ERROR';

export const GET_HISTORY_DEVICE_EXCEL: string = 'GET_HISTORY_DEVICE_EXCEL';
export const GET_HISTORY_DEVICE_EXCEL_SUCCESS: string = 'GET_HISTORY_DEVICE_EXCEL_SUCCESS';
export const GET_HISTORY_DEVICE_EXCEL_ERROR: string = 'GET_HISTORY_DEVICE_EXCEL_ERROR';